import { Bleed, ExpandableCard, H6, MarginBox, ResponsiveTable, ResponsiveTableRow, Separator } from '@fs/zion-ui'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ChangeHistoryRow from './ChangeHistoryRow'

const HistoryChangeCard = ({ label, change, expanded = true }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(expanded)

  useEffect(() => {
    setOpen(expanded)
  }, [expanded])

  return (
    <ExpandableCard
      title={
        <H6>
          {t('history-viewer.group.title', '{slsType} History', {
            slsType: label,
          })}
        </H6>
      }
      open={open}
      setOpen={() => setOpen((prev) => !prev)}
    >
      <Bleed top>
        <MarginBox marginX="sm">
          <ResponsiveTable
            totalColumnCount={3}
            atSizeColumns={{
              default: {
                labels: [
                  t('history-viewer.changes-table.change.label', 'Change'),
                  t('history-viewer.changes-table.value.label', 'Value'),
                  t('history-viewer.changes-table.date.label', 'Date'),
                ],
              },
            }}
          >
            {change?.items && change.items.length > 0 ? (
              change.items.map((item) => (
                <ChangeHistoryRow key={`${item.actionId}_${item.sequenceNumber}`} change={item} noHeadingOnValue />
              ))
            ) : (
              <ResponsiveTableRow
                column1={t('history-viewer.filter.no-results', 'No changes exist for the selected filter.')}
                column1span={3}
              />
            )}
          </ResponsiveTable>
          <Separator size="sm" />
        </MarginBox>
      </Bleed>
    </ExpandableCard>
  )
}

export default HistoryChangeCard
